
import './css/main.css';

import React, {useEffect} from 'react';



import { LoginForm } from './components/forms/Login.js';
import { HomeForm } from './components/forms/Home.js';
import { LogoutForm } from './components/forms/Logout.js';
import { ViewMembershipForm } from './components/forms/ViewMembership.js';
import { Routes, Route,useNavigate, useLocation} from "react-router-dom";
import { VisitsForm } from './components/forms/Visits.js';

import {AdminSearchForm} from './components/forms/AdminSearch.js'
import { PermissionDeniedForm } from './components/forms/PermissionDenied.js';
import { AdminViewMemberForm } from './components/forms/AdminViewMember.js';
import { AdminEditMemberForm } from './components/forms/AdminEditMember.js';
import { AdminVisitsForm } from './components/forms/AdminVisits.js';
import { AdminPhotoForm } from './components/forms/AdminPhoto.js';
import { AdminNewMemberForm } from './components/forms/AdminNewMember.js';
import { AdminYearsForm } from './components/forms/AdminYears.js';
import { useAPICall } from './hooks/useAPICall.js';
import { AdminFamiliesForm } from './components/forms/AdminFamilies.js';
import { AdminPosUploadForm } from './components/forms/AdminPosUpload.js';
import { ForgotPasswordForm } from './components/forms/ForgotPassword.js';
import { ResetPasswordForm } from './components/forms/ResetPassword.js';
import { AdminReportsForm } from './components/forms/AdminReports.js';
import { ReportMembershipSummaryForm } from './components/forms/ReportMembershipSummary.js';
import { ReportLapsedMembershipForm } from './components/forms/ReportLapsedMembership.js';
import { ReportCurrentROsForm } from './components/forms/ReportCurrentROs.js';
import { ReportMemberVisitsForm } from './components/forms/ReportMemberVisits.js';
import { ReportVisitsByDateForm } from './components/forms/ReportVisitsByDate.js';
import { ViewMembershipCardForm } from './components/forms/ViewMembershipCard.js';
import { ReportPendingMembershipForm } from './components/forms/ReportPendingMembership.js';


export function Main()
{
  const { ShowSpinner, ShowError } = useAPICall();

    const navigate = useNavigate();
    
    const location = useLocation();
    
    useEffect(() => 
    {
      
      if(sessionStorage.getItem("Authed") !== 'true' && 
      location.pathname !== "/Login" && 
      location.pathname !== "/Logout" &&
      location.pathname !== "/ForgotPassword" &&
      location.pathname !== "/ResetPassword")
      {
          navigate("/Login");
      }
    })

    return (

      <div>
         <div className='contentpage'>
          {ShowError()}
          {ShowSpinner()}  
          <Routes>
            <Route path="/" >                        
              <Route index path="/Home" element={<HomeForm/>}/>
              <Route path="/ViewMembership" element={<ViewMembershipForm/>}/>
              <Route path="/Visits" element={<VisitsForm/>}/>
              <Route path="/Logout" element={<LogoutForm/>}/>      
              <Route path="/Login" element={<LoginForm/>}/>  
              <Route path="/ForgotPassword" element={<ForgotPasswordForm/>} />
              <Route path="/Admin" element={<AdminSearchForm/>}/>  
              <Route path="/ViewMember" element={<AdminViewMemberForm/>}/>  
              <Route path="/EditMember" element={<AdminEditMemberForm/>}/>  
              <Route path="/AdminVisits" element={<AdminVisitsForm/>}/>  
              <Route path="/AdminPhoto" element={<AdminPhotoForm/>}/>  
              <Route path="/AdminNewMember" element={<AdminNewMemberForm/>}/>
              <Route path="/AdminYears" element={<AdminYearsForm/>}/>
              <Route path="/AdminFamilies" element={<AdminFamiliesForm/>}/>
              <Route path="/PermissionDenied" element={<PermissionDeniedForm/>}/>  
              <Route path="/AdminPosUpload" element={<AdminPosUploadForm/>} />              
              <Route path="/ResetPassword" element={<ResetPasswordForm/>}/>
              <Route path="/AdminReports" element={<AdminReportsForm/>}/>
              <Route path="/ReportMembershipSummary" element={<ReportMembershipSummaryForm/>}/>
              <Route path="/ReportLapsedMembership" element={<ReportLapsedMembershipForm/>}/>
              <Route path="/ReportPendingMembership" element={<ReportPendingMembershipForm/>}/>
              <Route path="/ReportCurrentROs" element={<ReportCurrentROsForm/>}/>
              <Route path="/ReportMemberVisits" element={<ReportMemberVisitsForm/>}/>
              <Route path="/ReportVisitsByDate" element={<ReportVisitsByDateForm/>}/>
              <Route path="/ViewMembershipCard" element={<ViewMembershipCardForm/>}/>

            </Route>                            
          </Routes>                   
        </div>
        
       </div>
    );
}



export default Main;


